export const HIGH_INCOME = {
    value: "HIGH_INCOME",
    key: "clients.client.categorisation.financialForm.form.segmentationTypes.highIncome",
};

export const MIDDLE_INCOME = {
    value: "MIDDLE_INCOME",
    key: "clients.client.categorisation.financialForm.form.segmentationTypes.middleIncome",
};

export const LOW_INCOME = {
    value: "LOW_INCOME",
    key: "clients.client.categorisation.financialForm.form.segmentationTypes.lowIncome",
};

export const NOT_BILLABLE = {
    value: "NOT_BILLABLE",
    key: "clients.client.categorisation.financialForm.form.segmentationTypes.notBillable",
};

export default [HIGH_INCOME, MIDDLE_INCOME, LOW_INCOME, NOT_BILLABLE];



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/categorisation/enums/categorisationSegmentationTypes.js